import { Link } from 'react-router-dom';

const footerLinks = [
  {
    title: '内容分类',
    links: [
      { label: '法律法规', href: '/category/falv-fagui' },
      { label: '内容分级', href: '/category/neirong-fenji' },
      { label: '安全指引', href: '/category/anquan-zhiyin' },
    ],
  },
  {
    title: '平台服务',
    links: [
      { label: '平台合规', href: '/category/pingtai-hegui' },
      { label: '年龄验证', href: '/category/nianling-yanzheng' },
      { label: '关于我们', href: '/about' },
    ],
  },
  {
    title: '法律声明',
    links: [
      { label: '隐私政策', href: '#' },
      { label: '使用条款', href: '#' },
      { label: '免责声明', href: '#' },
    ],
  },
];

export default function Footer() {
  return (
    <footer className="bg-background-950 text-foreground-200">
      <div className="w-full px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-primary-500 text-background-50">
                <i className="ri-shield-check-line text-lg"></i>
              </div>
              <span className="text-lg font-semibold font-heading text-background-50">
                合规指引平台
              </span>
            </div>
            <p className="text-sm text-foreground-400 leading-relaxed">
              致力于为成年用户提供专业、全面的十八禁内容合规指引与安全教育。帮助用户了解法律边界，确保在合法合规前提下安全浏览。
            </p>
          </div>

          {footerLinks.map((group) => (
            <div key={group.title}>
              <h4 className="text-sm font-semibold text-background-50 mb-4">
                {group.title}
              </h4>
              <ul className="space-y-2.5">
                {group.links.map((link) => (
                  <li key={link.label}>
                    <Link
                      to={link.href}
                      className="text-sm text-foreground-400 hover:text-background-50 transition-colors duration-200"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-12 pt-8 border-t border-foreground-800/50 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-500">
            &copy; 2024-2026 十八禁合规指引平台 版权所有
          </p>
          <p className="text-xs text-foreground-600">
            本站内容仅供成年用户合规参考，不构成法律建议
          </p>
        </div>
      </div>
    </footer>
  );
}